export default __webpack_public_path__ + "static/media/espiritual4.aac19e16.jpg";